import { JSX } from 'react';
import RioglyphIcon from '../../wrapper/RioglyphIcon';

export const HeaderIcon = (props: { type: string }): JSX.Element => (
    <RioglyphIcon type={props.type} size={'large'} className={'margin-right-5'} />
);
